import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { AccountProfileFacade } from "../../modules/account-profile";
import { UsersSelectors } from "../../modules/user";
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'display-name',
  templateUrl: './display-name.component.html',
  styleUrl: './display-name.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
  ],
})
export class DisplayNameComponent {

  @Input() textSize: string = 'medium';
  @Input() textAlign: 'center' | 'left' | 'right' | 'justify' = 'left';
  @Input() iconSize: string = '22px';
  @Input() textWeight: string = 'bold'

  public authenticatedUser$ = this.store.select(UsersSelectors.selectAuthenticatedUser);
  public authenticatedUserName$ = this.authenticatedUser$.pipe(
    map(user => user?.name))
  public accountProfile$ = this.accountProfileFacade.profile$

  constructor(private store: Store,
    private accountProfileFacade: AccountProfileFacade) {
  }

}
